<template>
  <div class="mb-5">
    <h2 class="text-lg text-white">Billing History</h2>
    <span class="text-gray-600">
      Your invoices and receipts for all payments made on your Arcweave account
    </span>
  </div>
  <div v-if="isLoading">
    <Spinner />
  </div>
  <Table v-else>
    <TableHeader>
      <TableRow class="border-neutral-700">
        <TableHead>Date</TableHead>
        <TableHead>Description</TableHead>
        <TableHead>Amount</TableHead>
        <TableHead class="text-right" />
      </TableRow>
    </TableHeader>
    <TableBody v-if="invoices && invoices.length">
      <TableRow
        v-for="invoice in invoices"
        :key="invoice.id"
        class="border-neutral-700"
      >
        <TableCell class="text-neutral-300">{{ invoice.date }}</TableCell>
        <TableCell class="text-neutral-300">
          {{ invoice.description }}
        </TableCell>
        <TableCell class="text-neutral-300">{{ invoice.amount }}</TableCell>
        <TableCell class="text-neutral-300 text-right">
          <a :href="invoice.url" target="_blank" class="text-neutral-300">
            <Newspaper :size="20" />
            <span class="sr-only">Invoice</span>
          </a>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
  <div
    v-if="!invoices || invoices.length === 0"
    class="text-center text-neutral-50 text-md mt-2"
  >
    No invoices yet
  </div>
</template>

<script setup>
import Spinner from '@ui/components/Spinner.vue';
import { useQuery } from '@tanstack/vue-query';
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
  TableCell,
} from '@ui/components/table';
import requests from '@vuex/requests';

import { Newspaper } from 'lucide-vue-next';
import { useStore } from 'vuex';

const store = useStore();

const { isLoading, data: invoices } = useQuery({
  queryKey: ['workspaceInvoices'],
  queryFn: () =>
    requests.workspaces.subscription.invoices(store.getters['workspace/getId']),
});
</script>

<style lang="scss" scoped></style>
